export default "__VITE_ASSET__Qj6fgYaO__"